import React, { JSX } from 'react';
import Style from './PostSkeleton.module.scss';

const PostSkeleton: React.FC = (): JSX.Element => {
  return (
    <article className={Style.post}>
      <div className={Style.date}></div>
      <div className={Style.category}>
        <span className={Style.label}></span>
      </div>
      <div className={Style.link}>
        <div className={Style.title}></div>
      </div>
    </article>
  );
};

export default PostSkeleton;
